export const MAX_CAPTION_LENGTH = 2200;
export const MIN_SLIDESHOW_IMAGES = 2;
export const MAX_SLIDESHOW_IMAGES = 10;
export const VALID_VIDEO_ASPECT_RATIOS = ['1:1', '16:9', '9:16'];
export const VALID_VIDEO_EXTENSION = ['mp4'];

export const COOKIES_FILE_PATH = 'cookies.json';
export const BASE_URL = 'https://i.instagram.com';
